module.exports = __webpack_public_path__ + "media/images/cw_logo-041a75effc6264ba0fecfd038fca38a8.svg";